import { InvoiceAmountCreateDTO, InvoiceAmountDTO, InvoiceAmountFilterDTO, InvoiceAmountFindAllResponseDTO, PartitionFiltersDTO, PartitionFindAllResponseDTO } from "./dto";
import { InvoiceAmountServiceImpl } from "./serviceImpl";

export interface InvoiceAmountService {
    findAllInvoiceAmount(filters: InvoiceAmountFilterDTO): Promise<InvoiceAmountFindAllResponseDTO>
    createInvoiceAmount(body: InvoiceAmountCreateDTO): Promise<string>
    findByIdInvoiceAmount(id: string): Promise<InvoiceAmountDTO>
    editInvoiceAmount(id: string, body: InvoiceAmountCreateDTO): Promise<void>
    recoverPartitionMetrics(): Promise<void>
    partitionPartitionMetrics(): Promise<void>
    findAllPartition(filters: PartitionFiltersDTO): Promise<PartitionFindAllResponseDTO>
}

export function NewInvoiceAmountService(): InvoiceAmountService {
    return new InvoiceAmountServiceImpl();
}
